import { render, staticRenderFns } from "./FornecedorHome.vue?vue&type=template&id=10e92059"
import script from "./FornecedorHome.vue?vue&type=script&lang=js"
export * from "./FornecedorHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports